export const GET_SPOTIFY_PLAYLISTS = 'GET_SPOTIFY_PLAYLISTS';
export const LOAD_MORE_SPOTIFY_PLAYLISTS = 'LOAD_MORE_SPOTIFY_PLAYLISTS';
